//
// Action types
//

export const UPDATE_FILTER_VALUE = "UPDATE_FILTER_VALUE";
export const RESET_ALL_FILTERS = "RESET_ALL_FILTERS";

//
// Action creators
//

export function updateFilterValue(resourcesListKey, key, value) {
  return {
    type: UPDATE_FILTER_VALUE,
    resourcesListKey,
    key,
    value
  };
}

export function resetAllFilters(resourcesListKey) {
  return {
    type: RESET_ALL_FILTERS,
    resourcesListKey
  };
}

function updateFilterValueHandler(state, key, value) {
  return { ...state, [key]: value };
}

function resetAllFiltersHandler() {
  return {};
}

//
// Reducer and handlers
//

export function reduceFilters(state, action) {
  switch (action && action.type) {
    case UPDATE_FILTER_VALUE:
      return updateFilterValueHandler(state, action.key, action.value);

    case RESET_ALL_FILTERS:
      return resetAllFiltersHandler();

    default:
      return state || {};
  }
}
